"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRecord = void 0;
const command_manager_1 = require("../../command_manager");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
const player_1 = require("../../modules/shared/player");
exports.deleteRecord = {
    undoable: true,
    execute: (context, options) => {
        const { model: state, ldcMaintainer } = context;
        const { data } = options;
        const datasheetId = options.datasheetId || store_1.Selectors.getActiveDatasheetId(state);
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const linkField = [];
        for (const fieldId in snapshot.meta.fieldMap) {
            const field = snapshot.meta.fieldMap[fieldId];
            if (field.type === types_1.FieldType.Link) {
                linkField.push(field);
            }
        }
        const getFieldByFieldId = (fieldId) => {
            return store_1.Selectors.getField(state, fieldId, datasheetId);
        };
        const actions = model_1.DatasheetActions.deleteRecords(snapshot, {
            recordIds: data,
            getFieldByFieldId,
            state,
        });
        /**
         * According to the self-association field, generate a map, the key is recordId,
         * and the value is the id array of those records associated with this recordId.
         * Multiple self-associated fields will have multiple such maps
         */
        const fieldRelinkMap = {};
        linkField.filter(field => {
            // Filter out the associated field of the word table
            return !field.property.brotherFieldId;
        }).forEach(field => {
            const reLinkRecords = {};
            Object.values(snapshot.recordMap).forEach(v => {
                const linkRecords = v.data[field.id];
                if (linkRecords) {
                    linkRecords.forEach(id => {
                        if (!reLinkRecords[id]) {
                            reLinkRecords[id] = [];
                        }
                        reLinkRecords[id].push(v.id);
                    });
                }
            });
            fieldRelinkMap[field.id] = reLinkRecords;
        });
        data.forEach(recordId => {
            const record = snapshot.recordMap[recordId];
            if (!record) {
                return;
            }
            linkField.forEach((field) => {
                let oldValue;
                // two tables are associated
                if (field.property.brotherFieldId) {
                    oldValue = record.data[field.id];
                }
                else {
                    // self-association
                    oldValue = fieldRelinkMap[field.id][record.id] || undefined;
                    // LinkedActions are not generated when the self-table is associated and the associated record contains the deleted record itself
                    oldValue = oldValue === null || oldValue === void 0 ? void 0 : oldValue.filter(item => !data.includes(item));
                }
                const linkedSnapshot = store_1.Selectors.getSnapshot(state, field.property.foreignDatasheetId);
                // When the associated field cell itself has no value, do nothing
                if (!(oldValue === null || oldValue === void 0 ? void 0 : oldValue.length)) {
                    return;
                }
                if (!linkedSnapshot) {
                    return player_1.Player.doTrigger(player_1.Events.app_error_logger, {
                        error: new Error(`foreignDatasheet:${field.property.foreignDatasheetId} has been deleted`),
                        metaData: { foreignDatasheetId: field.property.foreignDatasheetId },
                    });
                }
                ldcMaintainer.insert(state, linkedSnapshot, record.id, field, null, oldValue);
            });
        }, []);
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
/*

 declare module '../../command_manager/command_manager' {
 interface CollaCommandManager {
 execute(options: IAddRecordsOptions & { cmd: 'AddRecords' }): ICollaCommandExecuteResult<IAddRecordsResult>;
 }
 }

 */
//# sourceMappingURL=delete_record.js.map